<template>
  <div>
    <div v-if="!additionalMaterialTypes.length" class="no-actions-message">There are no Additional Materials to show.</div>
    <ul v-if="additionalMaterialTypes.length">
      <li v-for="additionalMaterialType in additionalMaterialTypes" :key="additionalMaterialType.additionalMaterialTypeId">
        {{ additionalMaterialType.name }} ({{ additionalMaterialType.required ? "Required" : "Optional" }})
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    additionalMaterialTypes: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
</style>
